<template>
    <div class="home-page">
        <div class="home-title-bar dsp-flex">
            <div class="home-title-side home-title-side-left"><!-- <i class="iconfont icon-xiangzuo"></i> --></div>
            <div class="home-title-mid"><span class="home-title-title">生日五行强弱测测</span></div>
            <div class="home-title-side"><span class="home-title-button" @click="clickReport">我的报告</span></div>
        </div>
        <!-- 1、介绍内容部分 -->
        <div class="home-page-top-content">
            <div class="home-main-content">
                <p>经现代科学证实，世界是由能量组成，而我们每个人、每个事物都是能量体。生活在地球上的人类必然受天体干扰、地球磁场支撑等时间及空间综合能量的作用，进而产生了人的运势高低起伏轨迹、我们的祖先早在科学诞生数千年前就已证实世界由金木水火土五行能量组成，而生活在自然界中的人类也不例外。</p>
                <br />
                <p>每个人以生日即生辰时间对应出生时地球与周围天体之间的相对位置，从而产生能量关系并定义出五行能量的构成，可据此推算运势起伏。进而我们可以选择适合的五行颜色、方位、事物、日子或吉祥物等帮助大家趋吉避凶。</p>
            </div>
        </div>
        
        <!-- 2、输入表单 -->
        <div class="home-page-bottom-content">
            <home-evaluation-form></home-evaluation-form>
        </div>

        <!-- 4、输入生日日期组件 -->
        <van-popup class="van-popup-strong-input-birthday" v-bind:value="showStrongBirthdayPop" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <strong-input-birthday-panel></strong-input-birthday-panel>
        </van-popup>

        <!-- 5、输入地址组件 -->
        <van-overlay v-show="showStrongAreaPop" @click="clickShowAreaOverlay" />
        <vant-area v-show="showStrongAreaPop" v-bind:parentNode="parentNode" :class="'strong-vant-area'"></vant-area>
    </div>
</template>

<script>
import VantArea from '../../layouts/vant/VantArea.vue'
import HomeEvaluationForm from '../../layouts/strong/HomeEvaluationForm.vue'
import StrongInputBirthdayPanel from '../../components/strong/StrongInputBirthdayPanel.vue';
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
export default {
    name: 'Home',
    components: { VantArea, HomeEvaluationForm, StrongInputBirthdayPanel },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        showStrongBirthdayPop() {
            return this.$store.state.strong.showStrongBirthdayPop;
        },
        showStrongAreaPop() {
            return this.$store.state.strong.showStrongAreaPop;
        }
    },
    data() {
        return {
            parentNode: {'name': 'StrongHome'},
        }
    },
    mounted() {
        DOM.setDocumentTitle(doctitle.TITLE_STRONG);
        setTimeout(() => {
            if(!this.gotRecordData){
                this.$store.dispatch('record/initRecordList');
            }
            this.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var rootDom = document.getElementsByClassName('wrapper')[0];
            this.$el.style.width = rootDom.clientWidth + 'px';
            this.$el.style.height = innerHeight + 'px';

            var me = this;
            window.onresize = function() {
                me.$el.style.width = rootDom.clientWidth + 'px';
                me.$el.style.height = innerHeight + 'px';
            }
        },
        clickBack() {
            this.$router.replace('/collate');
        },
        clickReport() {
            this.$router.replace('/strong-myreport');
        },
        clickShowBirthdayOverlay() {
            this.$store.state.strong.showStrongBirthdayPop = false;
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        clickShowAreaOverlay() {
            this.$store.state.strong.showStrongAreaPop = false;
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },

    }
}
</script>